import { useRef } from "react";

function DirectionalButton({
  as: Element = "a",
  children,
  className = "",
  ...props
}) {
  const buttonRef = useRef(null);
  const opensQueryModal = props.href === "#contact";

  function setPointerPosition(event, prefix) {
    const button = buttonRef.current;
    const bounds = button.getBoundingClientRect();
    const x = event.clientX - bounds.left;
    const y = event.clientY - bounds.top;

    button.style.setProperty(`--${prefix}-x`, `${x}px`);
    button.style.setProperty(`--${prefix}-y`, `${y}px`);
  }

  function handlePointerEnter(event) {
    setPointerPosition(event, "fill");
  }

  function handlePointerLeave(event) {
    const button = buttonRef.current;
    const bounds = button.getBoundingClientRect();
    const x = event.clientX - bounds.left;
    const y = event.clientY - bounds.top;
    const distances = {
      top: y,
      right: bounds.width - x,
      bottom: bounds.height - y,
      left: x,
    };
    const exitSide = Object.entries(distances).reduce(
      (closest, [side, distance]) =>
        distance < closest.distance ? { side, distance } : closest,
      { side: "top", distance: Number.POSITIVE_INFINITY },
    ).side;

    const exitPoints = {
      top: [bounds.width / 2, 0],
      right: [bounds.width, bounds.height / 2],
      bottom: [bounds.width / 2, bounds.height],
      left: [0, bounds.height / 2],
    };
    const [exitX, exitY] = exitPoints[exitSide];

    button.style.setProperty("--exit-x", `${exitX}px`);
    button.style.setProperty("--exit-y", `${exitY}px`);
  }

  return (
    <Element
      {...props}
      {...(opensQueryModal
        ? { "data-bs-toggle": "modal", "data-bs-target": "#queryModal" }
        : {})}
      ref={buttonRef}
      className={`default-btn ${className}`.trim()}
      onPointerEnter={handlePointerEnter}
      onPointerLeave={handlePointerLeave}
    >
      <span className="default-btn-label">{children}</span>
    </Element>
  );
}

export default DirectionalButton;
